import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { NbDialogService, NbMenuBag, NbMenuService } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AlertComponent } from '../../../common/components/dialog/alert/alert.component';
import { PageResult } from '../../../common/model/page-result';

@Component({
  selector: 'ngx-pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.scss'],
})
export class PagerComponent implements OnChanges, OnInit, OnDestroy {
  
  @Output() public changePage: EventEmitter<any> = new EventEmitter();
  @Output() public changedPageSize: EventEmitter<any> = new EventEmitter();
  
  @Input() public page: PageResult<any> = new PageResult<any>();
  @Input() public showPager: boolean = true;

  public pages: any;
  public startPage: number = 0;
  public endPage: number;

  public items = [
    { title: '35개씩 표시', data: 35 },
    { title: '100개씩 표시', data: 100 },
    { title: '500개씩 표시', data: 500 },
    { title: '1000개씩 표시', data: 1000 },
    { title: '10000개씩 표시', data: 10000 }
  ];

  private menuSubscription: Subscription;

  constructor(private dialogService: NbDialogService, private nbMenuService: NbMenuService) {}

  ngOnInit() {
    this.menuSubscription = this.nbMenuService.onItemClick()
    .pipe(filter(({ tag }) => tag === 'pageSizeMenu'))
    .subscribe((menu: NbMenuBag) => {

      if (this.page.size == menu.item.data) return;

      this.items.forEach((i: any)=>{
        if (i.hasOwnProperty('icon'))
          delete i.icon;
      });

      menu.item.icon = { icon: 'checkmark-circle-2-outline' };
      this.page.size = Number(menu.item.data);
      this.changedPageSize.emit(this.page.size);
    });

    this.items.forEach((i: any)=>{
      if (i.hasOwnProperty('icon'))
        delete i.icon;
      
      if (i.data == this.page.size)
        i.icon = { icon: 'checkmark-circle-2-outline' };
    });
  }

  ngOnDestroy(): void {
    this.menuSubscription?.unsubscribe();
  }

  ngOnChanges() {
    this.pages = [];
    if (this.page.totalPages < this.endPage) {
      this.endPage = this.page.totalPages;
    }

    if (this.page.totalPages === 0 || this.page.totalPages === 1) {
      this.pages = [0];
      return;
    }

    this.makePage(this.page.number).then((res) => {
      this.startPage = res;
      this.endPage = res + 5;

      if (this.endPage > this.page.totalPages) {
        this.endPage = this.page.totalPages;
      }

      for (let i = this.startPage; i < this.endPage; i++) {
        this.pages.push(i);
      }
    });
  }

  onChangePageSize(event): void {
    if (!event) return;

    this.page.size = event.target.value;
  }

  /**
   * 페이지 사이즈 변경 이벤트.
   * TODO : 무한페이징 사용하려면 서버 API 수정 필요. 현재 API에서 무조건 페이징처리함 (2020.02.09)
   */
  onClickPageSize() {
    if (this.page.size == 0) {
      this.page.size = 35;
      this.changedPageSize.emit(this.page.size);
    } else {
      const pop = this.dialogService.open(AlertComponent, {
        context: {
          confirm: true,
          title: '확인 메시지',
          message: '무제한표시',
        },
      });

      pop.onClose.subscribe((res) => {
        if (!res) return;

        this.page.size = 0;
        this.changedPageSize.emit(this.page.size);
      });
    }
  }

  changePageSize(event): void {
    if (!event) return;

    this.page.size = Number(event.target.value);
    this.changedPageSize.emit(this.page.size);
  }

  makePage(startPage): Promise<any> {
    return new Promise((resolve, reject) => {
      if (startPage === 0) {
        resolve(startPage);
      }

      for (let i = startPage; i >= 0; i--) {
        if (i % 5 === 0) {
          resolve(i);
        }
      }
    });
  }

  prevPage() {
    this.page.number = this.page.number - 1;
    if (this.page.number < 0) {
      this.page.number = 0;
      return;
    }

    this.changePage.emit(this.page.number);
  }

  firstPage() {
    if (this.page.number <= 0) {
      return;
    }

    this.page.number = 0;
    this.changePage.emit(this.page.number);
  }

  lastPage() {
    if (this.page.number >= this.page.totalPages - 1) {
      return;
    }

    this.page.number = this.page.totalPages > 0 ? this.page.totalPages - 1 : 0;
    this.changePage.emit(this.page.number);
  }

  manualChangePageNumber($event) {
    let currentPageNumber = this.page.number + 1;
    let pageNumber = Number($event.srcElement.value);
    let max = Number($event.srcElement.max);
    let min = Number($event.srcElement.min);

    if (pageNumber > max) {
      pageNumber = $event.srcElement.value = max;
    } else if (min > pageNumber) {
      pageNumber = $event.srcElement.value = min;
    }

    if (currentPageNumber == pageNumber) return;

    this.page.number = --pageNumber;

    this.changePage.emit(this.page.number);
  }

  nextPage() {
    this.page.number = this.page.number < 0 ? 0 : this.page.number + 1;
    if (this.page.number >= this.page.totalPages) {
      this.page.number = this.page.number - 1;
      return;
    }

    this.changePage.emit(this.page.number);
  }

  setPage(page: any, obj: any) {
    if (obj) {
      return false;
    }
    if (page === this.page.totalPages) {
      page--;
    }
    this.changePage.emit(page);
  }
}
